/**
 * Scroll-video duration from the live preview, in export pixels.
 *
 * The file is lead-in blank + credit PNGs + lead-out blank. Each blank is
 * one full frame (createBlankPng, height = videoHeight). Playback starts
 * with the lead-in filling the frame and ends when the lead-out fills it,
 * so the scroll distance is content + one blank (strip − one viewport).
 *
 * Credit height is taken from the inner content box (the element the PNG
 * is captured from), not the wrapper's border box — the wrapper can be
 * wider than that column, which was shortening the estimate.
 *
 * Prefer fpsNum/fpsDen (same rationals as export) over a float fps.
 */

function contentBox(block) {
  const inner = [...block.children].find(
    (child) =>
      child instanceof HTMLElement &&
      !child.classList.contains("watermark") &&
      !child.classList.contains("watermark_displaynone"),
  );
  return inner || block;
}

function toExportHeight(el, videoWidth) {
  const box = contentBox(el);
  const layoutWidth = Math.max(1, box.offsetWidth);
  const layoutHeight = Math.max(el.offsetHeight, el.scrollHeight, box.offsetHeight);
  return layoutHeight * (videoWidth / layoutWidth);
}

export function getScrollRunningTime({
  videoWidth,
  videoHeight,
  sppf,
  fps,
  fpsNum,
  fpsDen,
}) {
  const blocks = document.querySelectorAll(".blockWrapper");
  const pxPerFrame = Number(sppf);

  if (!blocks.length || !pxPerFrame || !videoWidth || !videoHeight) {
    return { min: 0, sec: 0 };
  }

  const num = Number(fpsNum);
  const den = Number(fpsDen);
  const frameDuration =
    num > 0 && den > 0 ? num / den : 1 / Math.max(0.0001, Number(fps) || 0);

  if (!frameDuration || !Number.isFinite(frameDuration)) {
    return { min: 0, sec: 0 };
  }

  const contentHeight = Array.from(blocks).reduce(
    (sum, el) => sum + toExportHeight(el, videoWidth),
    0,
  );

  // preview-1 and the last preview are full-frame blanks in the file.
  const blankFrames = 2;
  const stripHeight = contentHeight + blankFrames * videoHeight;
  const scrollDistance = Math.max(0, stripHeight - videoHeight);

  const timeSec = (scrollDistance / pxPerFrame) * frameDuration;
  const totalSec = Math.max(0, Math.round(timeSec));

  return {
    min: Math.floor(totalSec / 60),
    sec: totalSec % 60,
  };
}
